// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-seasons-container","inner":"pages-seasons-inner"};